import { Autocomplete, Button, Card, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, Slide, TextField } from "@mui/material";
import React, { forwardRef, useEffect, useState } from "react";
import { IconCircleX } from "@tabler/icons-react";
import { IconAdjustmentsHorizontal, IconX } from "@tabler/icons-react";
import { removeEmptyKeys } from "helper/encodeData";
import { connect } from "react-redux";
import { getStateOption } from "store/app/farm-management/farm-records/actions";
import { setDistrictFilteredData } from "store/app/form-management/district-configuration/actions";
import VWDropdown from "components/dropdown";
import { unionBy } from 'lodash';

const districtStatusOption = [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
]

const Transition = forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);

const FilterDistrict = (props) => {

    const { open, onClose, districtFilterData, selectedState } = props;

    const [isAutoOpenDistrictStatus, setIsAutoOpenDistrictStatus] = useState();
    const [filter, setFilter] = useState();

    useEffect(() => {
        if (districtFilterData) {
            setFilter(districtFilterData);
        }
        else {
            setFilter(null);
        }
    }, [open]);

    //--------------------State---------------------------
    const [stateOptions, setStateOptions] = useState([]);

    const loadStateOption = (filter, page, pageSize) => {
        return props.getStateOption(filter, null, page, pageSize)
    }

    const validateOnchange = (e) => {
        const { name, value } = e.target;
        setFilter({
            ...filter,
            [name]: value,
        });
    }
    const handleSelect = (option, name) => {
        const { label } = option || {};
        setFilter({
            ...filter,
            [name]: label,
        });
    }

    const handleMultiSelect = (option, name) => {
        const optionArray = option?.map((field) => field.label ? field.label : field);
        const optionString = optionArray?.length > 0 ? optionArray.join() : null;
        setFilter({
            ...filter,
            [name]: optionString,
        });
    }

    const handleFilter = (e) => {
        e.preventDefault();
        onClose();
        const nonEmptyData = removeEmptyKeys(filter);
        props.setDistrictFilteredData(nonEmptyData);
    }

    const handleFilterClear = (e) => {
        e.preventDefault();
        onClose();
        if (selectedState) {
            props.setDistrictFilteredData({ statename: selectedState });
        }
        else {
            props.setDistrictFilteredData();
        }
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    return (
        <>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                maxWidth={'md'}
                fullWidth
                keepMounted
                onClose={validateClose}
                sx={{
                    '&>div:nth-of-type(3)': {
                        justifyContent: 'flex-end',
                        '&>div': {
                            m: 0,
                            borderRadius: '10px 0px 0px 10px',
                            maxWidth: 450,
                            maxHeight: '100%'
                        }
                    }
                }}
            >
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Filters
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                <form>
                                    <Grid container rowGap={4} marginTop={2}>
                                        <Grid container rowGap={4} direction="column">
                                            <Grid item>
                                                <TextField
                                                    autoFocus
                                                    label="District Name"
                                                    fullWidth
                                                    size="small"
                                                    name='districtname'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.districtname}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <VWDropdown
                                                    label="State/Export Name"
                                                    name="statename"
                                                    multiple={true}
                                                    // disablePortal={true}
                                                    getOptions={loadStateOption}
                                                    onSelect={handleMultiSelect}
                                                    // isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                                    // selectedOption={selectedState ? selectedState : filter?.statename}
                                                    isOptionEqualToValue={(option, value) => option?.label?.toLowerCase() === value?.toLowerCase()}
                                                    selectedOption={filter?.statename ? filter.statename.includes(",") ? filter.statename.split(",") : [filter.statename] : []}
                                                    options={stateOptions}
                                                    setOptions={(options) => {
                                                        setStateOptions((prev) => unionBy(prev, options, "value"));
                                                    }}
                                                    isDisabled={selectedState || false}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Autocomplete
                                                    size="small"
                                                    disablePortal
                                                    options={districtStatusOption}
                                                    open={isAutoOpenDistrictStatus}
                                                    onOpen={() => setIsAutoOpenDistrictStatus(true)}
                                                    onClose={() => setIsAutoOpenDistrictStatus(false)}
                                                    onChange={(e, option) => handleSelect(option, 'districtstatus')}
                                                    value={filter?.districtstatus}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            label="District Status"
                                                        />
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                variant="contained"
                                                onClick={handleFilter}
                                                size="small"
                                                color="primary"
                                                startIcon={<IconAdjustmentsHorizontal />}
                                            >
                                                Apply Filters
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={handleFilterClear}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                                startIcon={<IconCircleX />}
                                            >
                                                Clear
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )
                }

            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    districtFilterData: state.districts.districtFilterData,
})
const mapDispatchToProps = (dispatch) => ({
    setDistrictFilteredData: (filter) => dispatch(setDistrictFilteredData(filter)),
    getStateOption: (filter, region, page, pageSize) => dispatch(getStateOption(filter, region, page, pageSize)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FilterDistrict);